<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between items-center">
        <div>{{ $t('shopSmsDetail.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form label-position="left" class="text-left">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item>
                <el-input :placeholder="$t('shopSmsDetail.enterPhoneNumber')"
                  v-model="shopSmsDetailInfo.conditions.link" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" size="small" @click="_queryShopSmsDetailMethod()" icon="el-icon-search">
                {{ $t('shopSmsDetail.query') }}
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top">
      <div slot="header" class="flex justify-between items-center">
        <div>{{ $t('shopSmsDetail.sendRecords') }}</div>
        <div class="" style="top:10px;">
          <el-button type="default" size="small" @click="$router.go(-1)">
            {{ $t('shopSmsDetail.back') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="shopSmsDetailInfo.details" border style="width: 100%">
          <el-table-column prop="detailId" :label="$t('shopSmsDetail.detailId')" align="center" />
          <el-table-column prop="shopName" :label="$t('shopSmsDetail.shopName')" align="center" />
          <el-table-column prop="smsContent" :label="$t('shopSmsDetail.smsContent')" align="center" />
          <el-table-column prop="link" :label="$t('shopSmsDetail.phoneNumber')" align="center" />
          <el-table-column prop="createTime" :label="$t('shopSmsDetail.sendTime')" align="center" />
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page.sync="shopSmsDetailInfo.conditions.page"
          :page-size="DEFAULT_ROWS" layout="total, prev, pager, next" :total="shopSmsDetailInfo.total"
          style="margin-top: 20px; text-align: right;" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { listShopSmsDetail } from '@/api/shop/shopSmsApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopSmsDetail',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      shopSmsDetailInfo: {
        details: [],
        total: 0,
        records: 1,
        moreCondition: false,
        shopId: '',
        conditions: {
          shopId: '',
          link: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listShopSmsDetails(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    async _listShopSmsDetails(_page, _rows) {
      this.shopSmsDetailInfo.conditions.page = _page
      this.shopSmsDetailInfo.conditions.row = _rows
      this.shopSmsDetailInfo.conditions.shopId = getShopId()

      try {
        const res = await listShopSmsDetail(this.shopSmsDetailInfo.conditions)
        this.shopSmsDetailInfo.total = res.total
        this.shopSmsDetailInfo.records = res.records
        this.shopSmsDetailInfo.details = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listShopSmsDetails(val, this.DEFAULT_ROWS)
    },
    _queryShopSmsDetailMethod() {
      this._listShopSmsDetails(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}
</style>